import $ from "jquery";
class Menu {

    run() {
        this.navbarToggler();
        this.togglerMenu();
    }

    navbarToggler(){
        if ($('[data-component="hero"]').length > 0) {

            $(window).scroll(function () {
                let nav = $('.navbar');
                let hero = $('[data-component="hero"]');
                let nav_pos = nav.offset().top;
                let hero_pos = hero.height() + hero.offset().top;
                if (nav_pos > hero_pos) {
                    $('.navbar').addClass('navbar-dark');
                } else {
                    $('.navbar').removeClass('navbar-dark');
                }
            });
        } else {
            $('.navbar').addClass('navbar-dark');
        }

        var url = window.location.href;
        $('#aziendaTab li').each(function () {
            if ($('a', this).attr('href') == url) {
                $(this).addClass('link-active');
            }
        });
    }

    togglerMenu() {
        const overlayMenu = $('header .overlay-menu');

        $('#menu-toggler, #menu-closer').on('click',function(e){
            $('.overlay-menu').toggleClass('active');
            $('.navbar-wrapper').toggleClass('menu-open');
            $('#menu-toggler').toggleClass('x');
            $('#headerLogo').toggleClass('bright-7');
        });

        $(".nav__submenu").each(function () {
            $(this).closest(".nav__item").children(".nav__link").addClass('link-sub');
        });

        $(".link-sub").each(function () {
            $(this).on("click", function () {
                if ($(this).hasClass("active") === true) {
                    $(this).removeClass("active");
                    $(this).closest(".nav__item").find(".nav__submenu").removeClass('active');
                    $(this).closest(".nav__item").find(".nav__submenu").height(0);
                } else {
                    let setHeight = $(this).closest(".nav__item").find(".nav__submenu>div").outerHeight() + 140;
                    $(this).addClass("active");
                    $(this).closest(".nav__item").find(".nav__submenu").addClass('active');
                    $(this).closest(".nav__item").find(".nav__submenu").height(setHeight);
                }
            })
        })

        /****** Services overlay event handling*****/
        let mouse_is_inside = '';
        $('.overlay-services__content').hover(function () {
            mouse_is_inside = true;
        }, function () {
            mouse_is_inside = false;
        });

        const toggleServicesOverlay = action => {
            if (action === 'close') {
                $('.overlay-services').fadeOut(200);
            } else {
                $('.overlay-services').fadeIn(200);
            }
        };

        $('.overlay-services').click(function (e) {
            if (!mouse_is_inside) {
                $(this).fadeOut(200);
            }
        });

        $('.servicesOveralyToggler').click(() => toggleServicesOverlay());
        /****** End Services overlay event handling*****/

        /****** Remove active class function for nav tabs in Homepage and Certificate pages *****/
        $(function () {
            $('.s-our-services__navitem').removeClass('active');

            $('.s-our-services__navitem').click(function () {
                $('.s-our-services__navitem').removeClass('active');
                $('.serviceTabResolve').removeClass('active');
            });
        })
    }

}

const menu = new Menu();
export default menu;
